import { useEffect } from "react";
import { REDO, UNDO } from "./appsettings/interface";
import { useAppSettings } from "./AppSettingsContext";

/**
 * Registers application undo and redo shortcuts, respecting events handled by child controls.
 *
 * @returns No visible content.
 */
export const KeyboardBindings = (): null => {
  const { dispatch, undoIndex, undoHistory } = useAppSettings();

  useEffect(() => {
    /**
     * Dispatches an available history action for Ctrl+Z or Ctrl+Y.
     *
     * @param event - Keyboard event received anywhere in the application.
     */
    const handleKeyDown = (event: KeyboardEvent): void => {
      const key = typeof event.key === "string" ? event.key.toLowerCase() : "";
      if (
        event.ctrlKey &&
        !event.altKey &&
        !event.metaKey &&
        !event.shiftKey &&
        !event.defaultPrevented &&
        ((key === "z" && undoIndex > 0) || (key === "y" && undoIndex < undoHistory.length))
      ) {
        event.preventDefault();
        dispatch({ operation: key === "z" ? UNDO : REDO });
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [dispatch, undoIndex, undoHistory.length]);

  return null;
};

KeyboardBindings.displayName = "KeyboardBindings";
